import type { EmeraldListItemInputs } from '@emerald-react/list';
import { EmeraldListItem } from '@emerald-react/list';
import './styles.scss';

export type ListItemProps = EmeraldListItemInputs;

export function ListItem(props: ListItemProps) {
  return <EmeraldListItem {...props} />;
}
